module.exports = __webpack_public_path__ + "static/media/left-arrow.8c7f8eec.svg";